<template>
  <div>
    <demand-table :orderCode="orderCode" />
  </div>
</template>

<script>
import DemandTable from './components/table'
export default {
  components: { DemandTable },
  props: {
    orderCode: { type: String, default: '' },
  },
}
</script>
